// import React from "react";
// import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
// import { Toaster } from "react-hot-toast";
// import Login from "./pages/Login/login";
// import Dashboard from "./pages/Dashboard/Dashboard";
// import Patients from "./pages/Patients/Patients";
// import PatientDetail from "./pages/Patients/PatientDetail";
// import Duties from "./pages/Duties/Duties";
// import Profile from "./pages/Profile/Profile";
// import PortalLayout from "./components/ Portallayout";
// import Cookies from "js-cookie";

// const PrivateRoute = ({ children }) => {
//   const doctor = Cookies.get("doctor");
//   return doctor ? children : <Navigate to="/login" replace />;
// };

// function App() {
//   return (
//     <Router>
//       <Toaster position="top-right" />
//       <Routes>
//         <Route path="/login" element={<Login />} />
//         <Route
//           path="/"
//           element={
//             <PrivateRoute>
//               <PortalLayout />
//             </PrivateRoute>
//           }
//         >
//           <Route index element={<Navigate to="/dashboard" replace />} />
//           <Route path="dashboard" element={<Dashboard />} />
//           <Route path="patients" element={<Patients />} />
//           <Route path="patients/:sale_id" element={<PatientDetail />} />
//           <Route path="duties" element={<Duties />} />
//           <Route path="profile" element={<Profile />} />
//         </Route>
//         <Route path="*" element={<Navigate to="/dashboard" replace />} />
//       </Routes>
//     </Router>
//   );
// }

// export default App;

import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import Login from "./pages/Login/login";
import Dashboard from "./pages/Dashboard/Dashboard";
import Patients from "./pages/Patients/Patients";
import PatientDetail from "./pages/Patients/PatientDetail";
import Duties from "./pages/Duties/Duties";
import Profile from "./pages/Profile/Profile";
import PortalLayout from "./components/ Portallayout";
import Cookies from "js-cookie";

const PrivateRoute = ({ children }) => {
  const doctor = Cookies.get("doctor");
  return doctor ? children : <Navigate to="/login" replace />;
};

const PublicRoute = ({ children }) => {
  const doctor = Cookies.get("doctor");
  return doctor ? <Navigate to="/dashboard" replace /> : children;
};

function App() {
  return (
    <Router>
      <Toaster position="top-right" />
      <Routes>
        <Route
          path="/login"
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />
        <Route
          path="/"
          element={
            <PrivateRoute>
              <PortalLayout />
            </PrivateRoute>
          }
        >
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="patients" element={<Patients />} />
          <Route path="patients/:sale_id" element={<PatientDetail />} />
          <Route path="duties" element={<Duties />} />
          <Route path="profile" element={<Profile />} />
        </Route>
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </Router>
  );
}

export default App;